import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {environment} from "../../../environments/environment";
import {GetDocumentDetailRequest} from "../../models/document.request";
import {PlansService} from "../../services/plans.service";

@Component({
  selector: 'app-summary-discounts',
  templateUrl: './summary-discounts.component.html',
  styleUrl: './summary-discounts.component.scss'
})
export class SummaryDiscountsComponent implements OnInit, AfterViewInit {
  blobUrl: string = environment.blobStorageUrl +'/servicesanddisclosures/';
  feeFileName:string = 'FS_Smile_Generation_';
  discountFileName:string = 'SDF_Smile_Generation_';
  feeUrl:string = '';
  discountUrl:string = '';
  stateChosen:boolean = false;
  currentState:any = {};
  selectedState:string = '';
  stateAbbr:string = '';
  constructor(public em: EventsManager,private plansSrvc:PlansService) {

  }

  ngOnInit(): void {
    if(sessionStorage['state']){
      this.currentState = JSON.parse(sessionStorage['state']);
      this.selectedState = this.currentState.name;
      this.stateAbbr = this.currentState.abbr;
      this.getPlanDocuments();
    }
  }

  ngAfterViewInit(){
    this.scrollMe();
  }

stateChanged(state:any) {
    if(state.target.value !== 'none'){
      state.target.blur();
      this.stateAbbr = state.target.value;
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }

}

buildUrls(state:string){
    let urls:any = state.split(',');
  this.feeUrl = urls[1];
  this.discountUrl = urls[0];
  this.stateChosen = true;
}

openUrl(url:string){
    if(url == 'fees'){
      window.open(this.feeUrl);
    } else {
      window.open(this.discountUrl);
    }

}

  getPlanDocuments(){
    let docReq:GetDocumentDetailRequest = {category:'PlanDetails,WebsiteFlyers',brand:'sgdp',year:this.em.planYear,organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
    this.plansSrvc.getDocumentDetails(docReq).subscribe(
      (response) => {
        this.buildUrls(response);
        this.scrollMe();
      }
    )
  }

  scrollMe(){
    window.scrollTo(0,-window.scrollY);
  }
}
